import request from '@/utils/request2'

// 列表(主数据列表)
export function loadQuestionListDataApi(data) {
  return request({
    url: 'tms-web/question/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportQuestionListDataApi(data) {
  return request({
    url: 'tms-web/question/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveQuestionApi(data) {
  return request({
    url: 'tms-web/question/save',
    method: 'post',
    data
  })
}

// 变更状态
export function updateStatusQuestionApi(data) {
  return request({
    url: 'tms-web/question/updateStatus',
    method: 'post',
    data
  })
}

// 作废
export function deleteQuestionApi(data) {
  return request({
    url: 'tms-web/question/delete',
    method: 'post',
    data
  })
}

// 查看
export function viewQuestionApi(data) {
  return request({
    url: 'tms-web/question/view',
    method: 'post',
    data
  })
}

// 列表
export function listQuestionApi(data) {
  return request({
    url: 'tms-web/question/list',
    method: 'post',
    data
  })
}
